import { translate, TranslationEntity } from '@repo/utils';
import {
  Flex,
  Form, Select, Switch, Typography,
} from 'antd';
import { type CreateTaskNodeData } from 'automations/types/nodeSchemas/actionNodes';
import { APPOINTMENT_TASK_REMINDER_OPTIONS } from 'crm-atoms/data';
import { type TaskTemplateListType } from 'crm-atoms/queries';
import { useEffect, useMemo, useState } from 'react';

type CreateTaskContentType = CreateTaskNodeData['additionalOptions']['createTask'];

export default function ModifyReminderForm({
  taskTemplateData,
}: {
  taskTemplateData?: TaskTemplateListType
}) {
  const [reminderDisabled, setReminderDisabled] = useState(false);

  const form = Form.useFormInstance<CreateTaskContentType>();
  const taskTemplateId = Form.useWatch('templateId', form);

  const taskTemplateType = useMemo(() => {
    if (!taskTemplateId) return null;
    return taskTemplateData?.taskTemplates.find((template) => template.id === taskTemplateId.toString())?.taskType;
  }, [taskTemplateData, taskTemplateId]);

  useEffect(() => {
    if (reminderDisabled) {
      form.setFieldValue(['reminder'], {});
    }
  }, [form, reminderDisabled, taskTemplateType]);

  if (!taskTemplateId) return null;

  if (taskTemplateType === 'appointment') {
    return (
      <Flex gap={8} align="center">
        <Switch checked={!reminderDisabled} onChange={(checked) => setReminderDisabled(!checked)} />
        <Form.Item noStyle name={['reminder', 'seconds']} rules={[{ required: true, message: 'Reminder is required' }]}>
          <Select
            options={APPOINTMENT_TASK_REMINDER_OPTIONS}
            disabled={reminderDisabled}
            allowClear
          />
        </Form.Item>
      </Flex>
    );
  } else {
    return (
      <Typography.Text type="secondary">
        {translate(
          `Reminders are Only Configured for Appointment #{${TranslationEntity.task}}`,
          [{ pluralize: true, capitalize: true }],
        )}
      </Typography.Text>
    );
  }
}
